export default {
  TOAST_SHOW_SUCCESS: "toast/SHOW_SUCCESS",
  TOAST_SHOW_ERROR: "toast/SHOW_ERROR"
};
